import { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import LineItem from "./LineItem";
import Notification from "../../components/Notification";
import { withTranslation } from "@template/components/translation";
import ReservationMessage from "./ReservationMessage";
import TransitionList from "../TransitionList";
import styles from "./index.css";
import { APP_ROUTES } from "../../constants";

const languagesWithoutMessagePartOne = ["nl-NL", "sv-SE", "it-IT"];

import {
  ProgressIndicator,
  SIZE_MEDIUM
} from "@asosteam/asos-web-component-library-progress-indicator";

const firstTwentyItems = items => items.slice(0, 20);

const MiniBag = ({
  defaultStoreUrl,
  bagItemDeleteTransitionEnd,
  formatTranslation,
  items,
  lang,
  loading
}) => {
  const [renderableBagItems, setRenderableBagItems] = useState([]);
  const moreThanTwentyItems = renderableBagItems.length > 20;
  const loaded = renderableBagItems.length && !loading;

  const itemsToRender = useMemo(
    () => firstTwentyItems(renderableBagItems),
    [renderableBagItems]
  );

  const showMessagePartOne = !languagesWithoutMessagePartOne.includes(lang);

  useEffect(() => {
    setRenderableBagItems(prev => (items.length > prev.length ? items : prev));
  }, [items]);

  const setDeletingItem = useCallback(id => {
    setRenderableBagItems(prevState =>
      prevState.map(item =>
        item.id === id ? { ...item, transition: "exiting" } : item
      )
    );
  }, []);

  return loaded ? (
    <Fragment>
      <ReservationMessage />
      <div className={styles.miniBag}>
        <TransitionList
          onTransitionEnd={bagItemDeleteTransitionEnd}
          itemDeletedLabel={formatTranslation("minibag_itemdeleted")}
        >
          {itemsToRender.map(item => (
            <LineItem
              key={item.id}
              {...item}
              defaultStoreUrl={defaultStoreUrl}
              setDeletingItem={setDeletingItem}
            />
          ))}
        </TransitionList>
        {moreThanTwentyItems && (
          <Notification type="alert">
            <div className={styles.notification}>
              <span>
                {formatTranslation("minibag_footer_maximum_items_message")}
              </span>
              <span>
                {showMessagePartOne &&
                  formatTranslation("minibag_footer_view_bag_message_part_one")}
                <a
                  className={styles.link}
                  href={defaultStoreUrl.concat(APP_ROUTES.BAG_LINK)}
                >
                  {formatTranslation("minibag_footer_view_bag_message_link")}
                </a>
                {formatTranslation(
                  "minibag_footer_view_bag_message_part_two"
                ).replace(/^([^,])/, " $1")}
              </span>
            </div>
          </Notification>
        )}
      </div>
    </Fragment>
  ) : (
    <div className={styles.progressIndicatorContainer}>
      <ProgressIndicator
        size={SIZE_MEDIUM}
        progressMessage={formatTranslation("accessibility_label_loading")}
      />
    </div>
  );
};

MiniBag.propTypes = {
  defaultStoreUrl: PropTypes.string.isRequired,
  bagItemDeleteTransitionEnd: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  items: PropTypes.array,
  lang: PropTypes.string,
  loading: PropTypes.bool
};

MiniBag.defaultProps = {
  items: [],
  loading: false
};

export default withTranslation(MiniBag);
